import { useTranslation } from 'react-i18next';

import { LabeledInput } from '@work4all/components/lib/input/labeled-input';

import { WebShopTypePickerField } from '../../../../../../components/entity-picker/WebShopTypePickerField';
import { ControllerPlus } from '../../../../form-plus/controller-plus';
import { useFormContextPlus } from '../../../../form-plus/use-form-context-plus';
import { Collapse, ControlWrapper } from '../../../components';
import { WebShopMaskFormValue } from '../types';

export const WebShopOverlayControllerGeneralData = () => {
  const { t } = useTranslation();
  const { control } = useFormContextPlus<WebShopMaskFormValue>();

  return (
    <Collapse title={t('COMMON.GENERAL_DATA')} defaultOpen>
      <ControlWrapper columns={3}>
        <ControllerPlus
          control={control}
          name="name"
          render={({ field }) => {
            return <LabeledInput {...field} label={t('INPUTS.DESCRIPTION')} />;
          }}
        />

        <ControllerPlus
          control={control}
          name="customerNumber"
          render={({ field }) => {
            return (
              <LabeledInput {...field} label={t('COMMON.CUSTOMER_NUMBER')} />
            );
          }}
        />

        <ControllerPlus
          control={control}
          name="shopType"
          render={({ field }) => {
            return <WebShopTypePickerField {...field} />;
          }}
        />
      </ControlWrapper>

      <ControllerPlus
        control={control}
        name="url"
        render={({ field }) => {
          return <LabeledInput {...field} label={t('COMMON.FSP_URL')} />;
        }}
      />
    </Collapse>
  );
};
